import styled from "styled-components"

export const Wrapper = styled.div`
  position:absolute;
  box-sizing:border-box;
  left:25%;
  top:34%;
  height:48%;
  right:3%;
  background:rgba(0,0,0,.5);
  border:1px solid rgba(255,255,255,.5);
`

export const InnerWrapper = styled.div`
  margin-left:10%;
  position:relative;
`